import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiMachineDemosList, apiMachineDemosView } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/machineDemos/getData', async datas => {
    const { data } = await apiMachineDemosList(datas)
    return data
})

export const getView = createAsyncThunk('admin/machineDemos/getView', async id => {
    if (!id) return viewData
    const { data } = await apiMachineDemosView(id)
    data.file = ''
    return data
})

const viewData = {
    machine_id: '',
    file: '',
    comment: '',
}

export const machineDemoSlice = createSlice({
    name: 'admin/machineDemos',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData } = machineDemoSlice.actions

export default machineDemoSlice.reducer
